module.exports = "/_next/static/images/3-24a64ac9.gif";